import { BASE_URL } from '../config/api-routes';

export type BackendKind = 'node' | 'django';

/** Which API server the app talks to (Node Express vs Django compat). */
export function getBackendKind(): BackendKind {
  const explicit = (process.env.REACT_APP_BACKEND || '').trim().toLowerCase();
  if (explicit === 'node' || explicit === 'django') {
    return explicit;
  }

  const base = (BASE_URL || '').toLowerCase();
  if (base.includes(':8000') || base.includes('papi.useskipscreen.com')) {
    return 'django';
  }
  if (
    base.includes(':5001') ||
    base.includes('api.useskipscreen.com') ||
    base.includes('api.skipscreen')
  ) {
    return 'node';
  }

  return 'node';
}

export function isNodeBackend(): boolean {
  return getBackendKind() === 'node';
}

export function isDjangoBackend(): boolean {
  return getBackendKind() === 'django';
}

/** Node uses Socket.IO; Django uses per-conversation Channels WebSockets. */
export function supportsDedicatedChatSocket(): boolean {
  return isDjangoBackend();
}

/** HTTP origin for Socket.IO (not ws://). */
export function socketIoOrigin(): string {
  const ws = (process.env.REACT_APP_WS_URL || '').trim();
  if (ws) {
    if (ws.startsWith('wss://')) {
      return ws.replace('wss://', 'https://').replace(/\/$/, '');
    }
    if (ws.startsWith('ws://')) {
      return ws.replace('ws://', 'http://').replace(/\/$/, '');
    }
    return ws.replace(/\/$/, '');
  }

  const base = (BASE_URL || 'http://localhost:5001/').trim();
  return base.replace(/\/$/, '');
}
